import { Injectable } from '@angular/core';
import { AbstractHttpService } from '../commons/abstract-http.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PacDocumentos } from '../model/pack-documentos';
import { PackDocumento } from '../model/pack-documento';
import { Documento } from '../model/documento';
import { CredorDTO } from '../model/dto/credor.dto';
import { ResponseData } from '../model/response.data';
import { promise } from 'protractor';
import {TpDocumento} from "../model/tpDocumento";

@Injectable({
  providedIn: 'root'
})
export class DocumentoService extends AbstractHttpService {

  private DOCUMENTOS = 'documentos';
  private TP_DOCUMENTOS = 'tp_documentos';
  private TERMO = '/termo';
  private BUSCAR = '/buscar';

  constructor(http: HttpClient) {
    super(http);
  }

  getTipoDocumento(): Observable<TpDocumento[]> {
    return this.http.get<TpDocumento[]>(this.url + this.TP_DOCUMENTOS);
  }

  downloadTermo(id:number) {
    return this.http.get(this.url + this.DOCUMENTOS + this.TERMO + `/${id}`, {
            'responseType': 'blob'
          });
  }
  downloadDocs(keys) {
    return this.http.post(this.url + this.DOCUMENTOS + this.BUSCAR, keys,{
      'responseType': 'blob'
    });
  }
}
//   getTipoDocumentoHapMap(): Observable<Map<string, string[] >> {
//     return this.http.get<Map<string, string[]>>(this.url + this.ENDPOINT_OBTER_TIPO_DOCUMENTO_HASH);
//   }

//   salvarDocumentos(restituicaoDTO: CredorDTO, documentoPack: PacDocumentos): Observable<any> {
//     const formData = new FormData();
//     this.setarFormData(documentoPack, formData);
//     formData.set('restituicaoDTO', JSON.stringify(restituicaoDTO));
//     return this.postWithMultiPartFile<any>(this.ENDPOINT_SAVAR, formData);
//   }

//   anexarEmolumento(documento: PackDocumento): Observable<any> {
//     const formData = new FormData();
//     this.setarFormEmolumento(documento, formData);
//     return this.postWithMultiPartFile<any>(this.ENDPOINT_SALVAR_EMOLUMENTO, formData);
//   }
  
//   private setarFormEmolumento(documento: PackDocumento, formData: FormData) {
//     formData.append('descricao', documento.descricao);
//     formData.append('tipoDocumentoEnum', documento.tipoDocumentoEnum.key);
//     formData.append('extensao', documento.extensao);
//     formData.append('protocolo', documento.protocolo);
//     formData.append('arquivo', documento.arquivo, documento.arquivo['name']);
//   }

//   atualizarDocumento(idRestituicaoDoc: string, arquivo: File): Observable<any> {
//     const formData = new FormData();
//     formData.append('idRestituicaoDoc', idRestituicaoDoc);
//     formData.append('arquivo', arquivo, arquivo['name'])
// return this.postWithMultiPartFile(this.ENDPOINT_ATUALIZARDOCUMENTO, formData);
//   }


//   private setarFormData(pacDocumento: PacDocumentos, formData: FormData) {

//     pacDocumento.descricao.forEach(descricao => {
//       formData.append('descricao', descricao);
//     });

//     pacDocumento.tipoDocumentoEnum.forEach(tipoDocumentoEnum => {
//       formData.append('tipoDocumentoEnum', tipoDocumentoEnum.key);
//     });

//     pacDocumento.extensao.forEach(extensao => {
//       formData.append('extensao', extensao);
//     });

//     pacDocumento.arquivo.forEach(arquivo => {
//       formData.append('arquivo', arquivo, arquivo['name']);
//     });

//   }

//   protected postWithMultiPartFile<T>(relativePath: string, formData: FormData): Observable<T> {

//     return this.http.post<T>(this.url + relativePath, formData, { headers: DocumentoService.getMultiPartHeaders() });
//   }

//   static getMultiPartHeaders() {
//     const headers = new HttpHeaders();
//     headers.append('Authorization', 'Bearer');
//     headers.set('Accept', 'application/json');
//     return headers;

//   }

//   buscarDocumentos(protocolo: string): Observable<any> {
//     return this.getMethod(this.ENDPOINT_GET_BUSCAR_DOCUMENTOS, { 'protocolo': protocolo });
//   }
//   public obterArquivo(doc: DocumentoCredor): Observable<any> {

//     let headers = new HttpHeaders();

//     return this.getMethodParams<any>(this.ENDPOINT_BAIXAR_DOCUMENTO, {
//       'params': {
//         'hash': doc.chave,
//       },
//       'responseType': 'blob',
//       'headers': headers
//     });
//   }

//   visualizarDocumentacao(protocolo: string): Observable<any> {
//     return this.getMethodParams<any>(this.ENDPOINT_GET_VISUALIZAR_DOCUMENTACAO, {
//       'params': {
//         'protocolo': protocolo,
//       },
//       'responseType': 'blob',
//       'headers': new HttpHeaders()
//     });
//   }

